import { render, staticRenderFns } from "./SmallBusinessRateRelief.vue?vue&type=template&id=361d2025"
import script from "./SmallBusinessRateRelief.vue?vue&type=script&lang=js"
export * from "./SmallBusinessRateRelief.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports